import { render, staticRenderFns } from "./contactUsForApple.vue?vue&type=template&id=2a7ffbc8"
import script from "./contactUsForApple.vue?vue&type=script&lang=js"
export * from "./contactUsForApple.vue?vue&type=script&lang=js"
import style0 from "./contactUsForApple.vue?vue&type=style&index=0&id=2a7ffbc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports